import React, { useEffect } from 'react';
import TopTabs, { TopTab } from '../common/TopTabs';
import { useUrlTab } from '../../hooks/useUrlTab';
import { ChildProfile } from '../../models/childProfile';
import ChildDocuments from './ChildDocuments';
import OrganisationDocuments from './OrganisationDocuments';

export type DocumentsTabKey = 'child' | 'organisation';

const TABS: TopTab<DocumentsTabKey>[] = [
  { id: 'child', label: 'Child documents', icon: 'fa-child-reaching' },
  { id: 'organisation', label: 'Organisation documents', icon: 'fa-building' },
];

interface Props {
  childId: string | null;
  childProfiles: ChildProfile[];
  /** Notifies the parent which tab is active (so it can hide the child
   *  selector on the Organisation tab). Fires on mount and on every change. */
  onTabChange?: (tab: DocumentsTabKey) => void;
  /** Full-area child picker, supplied while the Child documents tab is waiting
   *  on a selection. Renders in place of the tab body so the tabs stay usable. */
  childPicker?: React.ReactNode;
}

// Two-tab Documents screen: per-child documents and organisation-wide documents
// (e.g. policies). Mirrors the Reports screen's tab treatment.
const DocumentsTabs: React.FC<Props> = ({ childId, childProfiles, onTabChange, childPicker }) => {
  const [tab, setTab] = useUrlTab<DocumentsTabKey>('tab', ['child', 'organisation'], 'child');

  useEffect(() => {
    onTabChange?.(tab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <div className="documents-tabs top-tabs-page" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, width: '100%' }}>
      <TopTabs<DocumentsTabKey> tabs={TABS} active={tab} onChange={setTab} ariaLabel="Documents" dataHelp="documents.tabs" />
      {tab === 'child'
        ? (childPicker ?? <ChildDocuments childId={childId} childProfiles={childProfiles} />)
        : <OrganisationDocuments />}
    </div>
  );
};

export default DocumentsTabs;
